var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_700, Card, Divider, LILAC_200, LILAC_400, Typography, getTestId, isFirstItem, isValidObject, useBreakpoint } from '@airtel/air-design-system';
import { useCallback, useRef } from 'react';
import { FlatList, View } from 'react-native';
import { ButtonWidget } from '../button-widget';
import { CalloutWidget } from '../callout-widget';
import { HeadingTab, KeyBenefitsSectionTab, SingleCardField, TitleTab, InfoSummaryCardCollapsibleSection, ProgressBarCollection } from './components';
import { TEXT_TYPE } from './InfoSummaryWidgetConstants';
import { getInfoSummaryWidgetStyles } from './InfoSummaryWidgetStyles';
import { onChildCardImpression } from '../../utils/CommonUtils';
export var InfoSummaryWidgetComponent = props => {
  var _props$detailsDataCar = props.detailsDataCardList,
    detailsDataCardList = _props$detailsDataCar === void 0 ? [] : _props$detailsDataCar,
    infoIconToolTipPropTypes = props.infoIconToolTipPropTypes,
    style = props.style,
    onUserAction = props.onUserAction,
    testID = props.testID,
    outerContainerStyle = props.outerContainerStyle,
    singleCardStyle = props.singleCardStyle,
    flatListStyle = props.flatListStyle,
    id = props.id,
    widgetCtaAccessibilityProps = props.widgetCtaAccessibilityProps,
    restProps = __rest(props, ["detailsDataCardList", "infoIconToolTipPropTypes", "style", "onUserAction", "testID", "outerContainerStyle", "singleCardStyle", "flatListStyle", "id", "widgetCtaAccessibilityProps"]);
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var summaryWidgetStyles = getInfoSummaryWidgetStyles(isSmallScreen);
  var rowButtonsWidgetProps = props === null || props === void 0 ? void 0 : props.rowButtonsWidgetProps;
  var collapsibleData = props === null || props === void 0 ? void 0 : props.collapsible;
  var setOfVisitedIds = useRef(new Set());
  var renderDescriptionRow = (singleCardDetails, index) => {
    return !!(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.descriptionText) && _jsx(View, Object.assign({
      style: summaryWidgetStyles === null || summaryWidgetStyles === void 0 ? void 0 : summaryWidgetStyles.headerWrapper
    }, {
      children: _jsx(View, Object.assign({
        style: summaryWidgetStyles.headerTextWrapper
      }, {
        children: _jsx(Typography, Object.assign({
          type: isSmallScreen ? TEXT_TYPE.BODY_PARA_SM : TEXT_TYPE.BODY_PARA_MD,
          color: BLACK_700,
          text: singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.descriptionText
        }, getTestId(testID + '_detailsDataCardList_' + index.toString(), 'descriptionText')))
      }))
    }));
  };
  var renderTopRow = (singleCardDetails, index) => {
    return _jsx(View, Object.assign({
      style: isValidObject(props === null || props === void 0 ? void 0 : props.collapsible) && isFirstItem(index) && summaryWidgetStyles.singleCardWrapper
    }, {
      children: _jsxs(View, Object.assign({
        style: {
          marginBottom: 16
        }
      }, {
        children: [_jsx(TitleTab, Object.assign({
          singleCardDetails: singleCardDetails,
          isMobileScreen: isSmallScreen,
          infoIconToolTipPropTypes: infoIconToolTipPropTypes,
          onUserAction: onUserAction
        }, getTestId(testID + '_detailsDataCardList', index.toString()))), _jsx(HeadingTab, Object.assign({
          singleCardDetails: singleCardDetails,
          isMobileScreen: isSmallScreen,
          onUserAction: onUserAction
        }, getTestId(testID + '_detailsDataCardList', index.toString()))), renderDescriptionRow(singleCardDetails, index)]
      }))
    }));
  };
  var getSingleCardDetailsWrapperStyle = (index, singleCardDetails) => {
    if (isValidObject(props === null || props === void 0 ? void 0 : props.collapsible) && index === 0) {
      if (isValidObject(singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.infoItemButtonsWidgetProps)) {
        return Object.assign(Object.assign({}, summaryWidgetStyles.collapsibleCardWrapper), summaryWidgetStyles === null || summaryWidgetStyles === void 0 ? void 0 : summaryWidgetStyles.marginBottom16);
      }
      return summaryWidgetStyles.collapsibleCardWrapper;
    } else {
      return summaryWidgetStyles.singleCardWrapper;
    }
  };
  var renderSingleDetails = (index, singleCardDetails) => {
    var _a, _b;
    var _singleCardDetails$pr = singleCardDetails.progressBarPosition,
      progressBarPosition = _singleCardDetails$pr === void 0 ? 'top' : _singleCardDetails$pr,
      infoItemButtonsWidgetProps = singleCardDetails.infoItemButtonsWidgetProps;
    return _jsxs(View, Object.assign({
      style: [Object.assign({}, getSingleCardDetailsWrapperStyle(index, singleCardDetails)), style]
    }, {
      children: [!isValidObject(props === null || props === void 0 ? void 0 : props.collapsible) ? renderTopRow(singleCardDetails, index) : isValidObject(props === null || props === void 0 ? void 0 : props.collapsible) && index != 0 && renderTopRow(singleCardDetails, index), progressBarPosition === 'top' && _jsx(ProgressBarCollection, Object.assign({
        singleCardDetails: singleCardDetails,
        onUserAction: onUserAction
      }, getTestId(testID + '_detailsDataCardList', index.toString()))), _jsx(SingleCardField, Object.assign({
        singleCardStyle: singleCardStyle,
        index: index,
        singleCardDetails: singleCardDetails,
        isMobileScreen: isSmallScreen,
        onUserAction: onUserAction
      }, getTestId(testID + '_detailsDataCardList_' + index.toString(), 'detailsData'))), progressBarPosition === 'bottom' && _jsx(ProgressBarCollection, Object.assign({
        singleCardDetails: singleCardDetails
      }, getTestId(testID + '_detailsDataCardList', index.toString()))), _jsx(KeyBenefitsSectionTab, Object.assign({
        singleCardDetails: singleCardDetails,
        isMobileScreen: isSmallScreen,
        onUserAction: onUserAction
      }, getTestId(testID + '_detailsDataCardList_' + index.toString(), 'viewDetailsCtaProps'))), !!singleCardDetails.calloutWidgetProps && _jsx(View, Object.assign({
        style: summaryWidgetStyles === null || summaryWidgetStyles === void 0 ? void 0 : summaryWidgetStyles.calloutWidgetWrapper
      }, {
        children: _jsx(CalloutWidget, Object.assign({}, singleCardDetails === null || singleCardDetails === void 0 ? void 0 : singleCardDetails.calloutWidgetProps, {
          onUserAction: onUserAction
        }, getTestId(testID + '_detailsDataCardList_' + index.toString(), 'collapsibleProps')))
      })), !!infoItemButtonsWidgetProps && _jsx(View, Object.assign({
        style: summaryWidgetStyles === null || summaryWidgetStyles === void 0 ? void 0 : summaryWidgetStyles.infoItemButtonWidgetContainer
      }, {
        children: _jsx(ButtonWidget, Object.assign({}, infoItemButtonsWidgetProps, {
          onUserAction: onUserAction,
          leftCta: Object.assign({}, ((_a = infoItemButtonsWidgetProps === null || infoItemButtonsWidgetProps === void 0 ? void 0 : infoItemButtonsWidgetProps.leftCta) === null || _a === void 0 ? void 0 : _a.title) && Object.assign(Object.assign({}, getTestId(testID + '_infoItemButtonsWidgetProps_leftCta', index.toString())), infoItemButtonsWidgetProps === null || infoItemButtonsWidgetProps === void 0 ? void 0 : infoItemButtonsWidgetProps.leftCta)),
          rightCta: Object.assign({}, ((_b = infoItemButtonsWidgetProps === null || infoItemButtonsWidgetProps === void 0 ? void 0 : infoItemButtonsWidgetProps.rightCta) === null || _b === void 0 ? void 0 : _b.title) && Object.assign(Object.assign({}, getTestId(testID + '_infoItemButtonsWidgetProps_rightCta', index.toString())), infoItemButtonsWidgetProps === null || infoItemButtonsWidgetProps === void 0 ? void 0 : infoItemButtonsWidgetProps.rightCta))
        }))
      }))]
    }));
  };
  var onViewableItemsChanged = useCallback(info => {
    onChildCardImpression(info, setOfVisitedIds, onUserAction, id);
  }, []);
  var renderInfoCardData = () => {
    var _a, _b;
    return _jsxs(View, {
      children: [_jsx(View, Object.assign({}, widgetCtaAccessibilityProps, {
        children: _jsx(FlatList, {
          data: detailsDataCardList,
          keyboardShouldPersistTaps: "handled",
          renderItem: _ref => {
            var index = _ref.index,
              item = _ref.item;
            return renderSingleDetails(index, item);
          },
          keyExtractor: (item, index) => {
            var _a;
            return (_a = "" + (item === null || item === void 0 ? void 0 : item.titleText) + index) !== null && _a !== void 0 ? _a : '';
          },
          ItemSeparatorComponent: () => _jsx(Divider, {
            color: LILAC_400,
            height: 1
          }),
          onViewableItemsChanged: onViewableItemsChanged,
          scrollEnabled: false,
          numColumns: 1,
          style: [flatListStyle]
        })
      })), !!rowButtonsWidgetProps && _jsx(View, Object.assign({
        style: summaryWidgetStyles === null || summaryWidgetStyles === void 0 ? void 0 : summaryWidgetStyles.buttonWidgetContainer
      }, {
        children: _jsx(ButtonWidget, Object.assign({}, rowButtonsWidgetProps, {
          onUserAction: onUserAction,
          leftCta: Object.assign({}, ((_a = rowButtonsWidgetProps === null || rowButtonsWidgetProps === void 0 ? void 0 : rowButtonsWidgetProps.leftCta) === null || _a === void 0 ? void 0 : _a.title) && Object.assign({
            testID: testID + '_rowButtonsWidgetProps_leftCta'
          }, rowButtonsWidgetProps === null || rowButtonsWidgetProps === void 0 ? void 0 : rowButtonsWidgetProps.leftCta)),
          rightCta: Object.assign({}, ((_b = rowButtonsWidgetProps === null || rowButtonsWidgetProps === void 0 ? void 0 : rowButtonsWidgetProps.rightCta) === null || _b === void 0 ? void 0 : _b.title) && Object.assign({
            testID: testID + '_rowButtonsWidgetProps_rightCta'
          }, rowButtonsWidgetProps === null || rowButtonsWidgetProps === void 0 ? void 0 : rowButtonsWidgetProps.rightCta))
        }))
      }))]
    });
  };
  return _jsx(_Fragment, {
    children: (detailsDataCardList === null || detailsDataCardList === void 0 ? void 0 : detailsDataCardList.length) > 0 && _jsx(Card, Object.assign({
      backgroundColor: LILAC_200,
      noPadding: true
    }, restProps, getTestId(testID), {
      style: [outerContainerStyle]
    }, {
      children: isValidObject(props === null || props === void 0 ? void 0 : props.collapsible) ? _jsxs(_Fragment, {
        children: [detailsDataCardList.length > 0 && renderTopRow(detailsDataCardList[0], 0), _jsx(InfoSummaryCardCollapsibleSection, Object.assign({}, collapsibleData, {
          children: renderInfoCardData()
        }))]
      }) : renderInfoCardData()
    }))
  });
};
InfoSummaryWidgetComponent.genericRendererKey = 'AirInfoSummaryWidget';